import { Injectable } from '@angular/core';
import { Url } from '../../../config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BranchDataDTO } from 'src/app/model/branch-data-dto.model';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LocalstorageService } from '../localstorage/localstorage.service';
import { timeout, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CampaignService {

   //private baseUrl: String = "http://192.168.0.161:8080";
  private baseUrl: String = environment.campaignDashboardUrl;
  private userService :String = environment.userServiceUrl;
  //private baseUrl1: String = environment.SMSUrl;
  private token:string = "eyJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiREVWIiwiZXhwIjoxNTU5MzY4NTI1LCJ1c2VySWQiOiIgIn0.RPUeREa8xOVS0ibvzt2KEPdGv1r0snVNmC07Se5VTCA";
  private messageSource = new BehaviorSubject('default message');
  currentMessage = this.messageSource.asObservable();

  constructor(private http: HttpClient) { }
  
  changeMessage(message: string) {
    this.messageSource.next(message)
  }
  
  getCards() {
    return this.http.get('../../assets/body/card.json')
    
  }

  getInstruction() {
    return this.http.get('../../assets/body/directions.json')
    
  }

  getData() {
    return this.http.get('../../assets/body/data.json')
  }

  getInfo() {
    return this.http.get('../../assets/body/info.json')
  }

  // post service to send exceldata to backend
  postExcelData(branchDataDto: BranchDataDTO): any {
    console.log('body in service ', branchDataDto.users);

    return this.http.post(this.baseUrl + `/campaign/dashboard/users/${branchDataDto.branchId}`, branchDataDto, {
      headers: new HttpHeaders().append('token', localStorage.getItem("token"))
    });

  }

  //service for reading error json file
  getError(): any {
    return this.http.get('../../assets/data/error.json');
  }

  getCampaignDashboardCount() {
    return this.http.get(this.baseUrl + Url.getCount, {
      headers: new HttpHeaders().append('token', localStorage.getItem("token"))
    });
  }

  getListData(campaignType: String) {
    console.log("Url:",this.baseUrl+Url.getListByCampaignType+campaignType);
    console.log("token",localStorage.getItem("token"));
    
    return this.http.get(this.baseUrl + Url.getListByCampaignType + campaignType, {
      headers: new HttpHeaders().append('token', localStorage.getItem("token"))
    });
  }

  getTemplate() {
    console.log("Url for getTemplate:",this.baseUrl+Url.getAllTemplate);
    console.log("token for getTemplate:",localStorage.getItem("token"));
    return this.http.get(this.baseUrl + Url.getAllTemplate, {
      headers: new HttpHeaders().append('token', localStorage.getItem("token"))
    })
  }


  getAllShortName() {
    return this.http.get(this.baseUrl + Url.getAllShortName, {
      headers: new HttpHeaders().append('token', localStorage.getItem("token"))
    });
  }




  getDetailsByTypeAndId(campaignType: String, campaignId: String) {
    return this.http.get(this.baseUrl + Url.getDetailsByCampaignTypeAndId + campaignType + '/' + campaignId, {
      headers: new HttpHeaders().append('token', localStorage.getItem("token"))
    });
  }

  addCollegeAndInstitute(data) {
    return this.http.post(this.baseUrl + Url.addInstituteAndCollege, data, {
      headers: new HttpHeaders().append('token', localStorage.getItem("token"))
    });
  }

  addOnlineCampaign(data) {
    return this.http.post(this.baseUrl + Url.addOnlineCampaign, data, {
      headers: new HttpHeaders().append('token', localStorage.getItem("token"))
    });
  }

  addBranch(data, institutionId: String) {
    console.log("url: ", this.baseUrl + Url.addBranch + '/' + institutionId);
    
    return this.http.post(this.baseUrl + Url.addBranch + '/' + institutionId, data, {
      headers: new HttpHeaders().append('token', localStorage.getItem("token"))
    });
  }

  getGraphDetail(institutionId) {
    return this.http.get(this.baseUrl + Url.allUserGraph + "/" + institutionId, {
      headers: new HttpHeaders().append("token", localStorage.getItem("token"))
    })
  }

  postWithTokens(options) {
    const headers = new HttpHeaders({
      'token': localStorage.getItem("token")
    });
    console.log(options);

    return this.http.post(this.baseUrl + options.purpose, options.body, { headers });
  }

  postWithoutTokens(options) {
  
    // console.log(options);

    return this.http.post(this.baseUrl + options.purpose, options.body);
  }

  getCampaignByShortname(shortName:string){
    return this.http.get(this.baseUrl + `/campaign/dashbaord/campaign/${shortName}`);
  }

  emailRegistrationLink(emailID) {
    return this.http.get(this.baseUrl + '/campaign/dashboard/user/portal/register/mcq?emailId=' + emailID);
    //return this.http.get("http://192.168.0.65:8087/campaign/dashboard/user/portal/register/mcq?emailId="+emailID);
  }
  registration(data, shortName) {
    return this.http.post(this.baseUrl + '/campaign/dashboard/user/register/mcq/' + shortName, data);
  }
  downloadDataService(data):any{
    console.log(data);
    
    return this.http.post(this.baseUrl+'/campaign/dashboard/exceldata',data,{
      headers: new HttpHeaders().append("token", localStorage.getItem("token"))
    }).pipe(
      timeout(10000),
      catchError(e => {
        // do something on a timeout
        return null;
      })
    );
  }
  
}
